import { connect, useDispatch } from 'react-redux';
import React from 'react';
import Location from '../components/Location';
import AccordionContent from '../components/AccordionContent';
import { useAccountDetails } from '../features/accountDetails/accountDetailsSlice';
import { buildLocations } from '../utils/buildLocations';
import { buildAllHours } from '../utils/buildAllHours';
import '../global-sass/main.scss';
import { setDetailedHours } from '../features/detailedHours/detailedHoursSlice';

const WidgetContainer = () => {
	const addResponse = useAccountDetails();
	const locations = buildLocations(addResponse);
	const dispatch = useDispatch();
	dispatch(setDetailedHours(buildAllHours(addResponse)));

	if (locations.length === 0) {
		return null;
	} else if (locations.length === 1) {
		return (
			<div
				className="contact-department-widget"
				data-test-id={addResponse.id}
			>
				<Location
					address={locations[0].address}
					city={locations[0].city}
					country={locations[0].country}
					postalCode={locations[0].postalCode}
					state={locations[0].state}
					hours={locations[0].hours}
					phones={locations[0].phones}
					timeZoneId={locations[0].timeZoneId}
					emailAddress={locations[0].email}
					isAccordion={false}
				/>
			</div>
		);
	} else {
		const accordionItems = locations.map((location, index) => ({
			id: `location-${index}`,
			title: location.departmentName,
			content: (
				<Location
					address={location.address}
					city={location.city}
					country={location.country}
					postalCode={location.postalCode}
					state={location.state}
					hours={location.hours}
					phones={location.phones}
					timeZoneId={location.timeZoneId}
					emailAddress={location.email}
					isAccordion
				/>
			)
		}));

		return (
			<div
				className="contact-department-widget"
				data-test-id={addResponse.id}
			>
				<AccordionContent items={accordionItems} />
			</div>
		);
	}
};

WidgetContainer.propTypes = {};

WidgetContainer.propTypes = {};

const mapStateToProps = (_state) => {
	return {};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
